import React, {Component} from 'react';
import PropTypes from 'prop-types';

import FeatureModal from '~/src/components/featureModal/FeatureModal';
import rollbar from '~/src/utilities/libs/rollbar';

import {withSettingsContext} from '~/src/components/context/SettingsContext';
import {checkLoginModal} from '~/src/utilities/helpers/login';
import {Time} from '~/src/utilities/constants/time';
import {trackGtm} from '~/src/utilities/tracking/gtm';
import {GtmEvents} from '~/src/utilities/constants/tracking';
import initPolyglot from '~/src/utilities/libs/polyglot';

import i18nStrings from './LoginModal.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

class LoginModal extends Component {
    onClose = () => {
        trackGtm(GtmEvents.LOGIN_OVERLAY_CLOSE, null);
        this.setState({showModal: false});
    };

    onLogin = () => {
        trackGtm(GtmEvents.LOGIN_OVERLAY_LOGIN, null);
    };

    onRegister = () => {
        trackGtm(GtmEvents.LOGIN_OVERLAY_REGISTER, null);
    };

    onMoreInfo = () => {
        trackGtm(GtmEvents.LOGIN_OVERLAY_INFORMATION, null);
    };

    static defaultProps = {
        delay: Time.TEN_SECONDS
    };

    state = {
        showModal: false
    };

    componentDidMount() {
        if (checkLoginModal(this.props.context.settings.isWebView)) {
            setTimeout(() => {
                this.setState({showModal: true});
                try {
                    const count = localStorage.getItem('loginModalCount');
                    localStorage.setItem('loginModalCount', count ? Number(count) + 1 : 1);
                    localStorage.setItem('loginModalTimestamp', Date.now());
                } catch (error) {
                    rollbar.info(`[LoginModal] Browser does not support LocalStorage API: ${error.message}`, error);
                }
                trackGtm(GtmEvents.LOGIN_OVERLAY_DISPLAY, null);
            }, this.props.delay);
        }
    }

    render() {
        if (!process.browser || !this.state.showModal) {
            return null;
        }

        return (
            <FeatureModal
                targetUri={window.location.href}
                onClose={this.onClose}
                title={getTranslation('title')}
                onLogin={this.onLogin}
                onRegister={this.onRegister}
                onMoreInfo={this.onMoreInfo}
            />
        );
    }
}

if (process.env.NODE_ENV === 'development') {
    LoginModal.propTypes = {
        delay: PropTypes.number
    };
}

export default withSettingsContext(LoginModal);
